import {
  Card,
  CardList,
  cardListStylesDashboard,
  cardListStylesNoGap,
  cardStylesNoGap,
  IEmptyMessageProps,
  ImageLazyLoader,
  Sizes,
  WidgetPanel,
  widgetPanelStylesCardList,
} from '@h2oai/ui-kit';
import { useCallback, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useHistory } from 'react-router-dom';

import { App } from '../../../ai.h2o.cloud.appstore';
import { useEnv, useUser } from '../../../utils/hooks';
import { redirectActionAppCard } from '../../AppStorePage/AppStorePage';
import { RoutePaths } from '../../Routes';

export interface IAppCardListWidgetProps {
  windowWidth: number;
  data: App[];
  title: string;
  loadingMessage?: string;
}

export const AppCardListWidget = ({ title, windowWidth, data, loadingMessage }: IAppCardListWidgetProps) => {
  const history = useHistory();
  const auth = useAuth();
  const env = useEnv();
  const user = useUser();
  const isPublicUser = !!env?.publicModeEnabled && user.isPublic;
  const isAuthUser = !!auth.user?.id_token;
  const [columnCount, setColumnCount] = useState(1);
  const [isContentReady, setIsContentReady] = useState(false);
  const onRefChange = useCallback(
    (el: HTMLDivElement) => {
      if (el && el.clientWidth) {
        const count = Math.ceil(el.clientWidth / Sizes.cardWidthOfWidget);
        if (count !== columnCount) {
          setColumnCount(count);
        }
      }
    },
    // eslint-disable-next-line
    [columnCount, windowWidth]
  );
  const emptyMessageProps: IEmptyMessageProps | undefined =
    !data || !data.length ? { message: `You don't have any apps` } : undefined;
  useEffect(() => {
    setIsContentReady(true);
  }, []);
  return (
    <WidgetPanel
      styles={widgetPanelStylesCardList}
      title={title}
      linkText="View all"
      linkOnClick={() => {
        history.push(RoutePaths.APPSTORE);
      }}
      loadingMessage={loadingMessage}
      emptyMessageProps={emptyMessageProps}
    >
      <CardList
        ref={onRefChange}
        styles={[cardListStylesNoGap, cardListStylesDashboard]}
        idField="id"
        nameField="title"
        data={data.slice(0, columnCount)}
        columnCount={columnCount}
        itemRenderer={(app: App) => (
          <Card<App>
            styles={cardStylesNoGap}
            data={app}
            data-test={`${app.name}--app-tile`}
            idField="id"
            titleField="title"
            imagePathField="iconLocation"
            useImageLazyLoader
            disableLikedButton={!isAuthUser}
            disableMenuButton={!isAuthUser}
            disablePinnedButton={!isAuthUser}
            onClick={() =>
              redirectActionAppCard(app, isPublicUser).then((path) => {
                window.location.href = path;
              })
            }
          />
        )}
      />
      <ImageLazyLoader
        containerSelector=".h2o-CardList-root"
        isBackgroundImage
        isReady={isContentReady}
        errorImagePath="logo512.png"
        onLoaded={() => setIsContentReady(false)}
      />
    </WidgetPanel>
  );
};
